import { Outlet } from "react-router-dom";
//@ts-ignore
import AccessDeny from "@assets/images/access-deny.png";

const ExpertPrivateRoute = () => {
  const expertId = localStorage.getItem("expertId");

  if (expertId) {
    return (
      <div>
        <Outlet />
      </div>
    );
  } else {
    return (
      <div className="w-[600px] m-auto mt-10">
        <img alt="access-deny" src={AccessDeny} />
      </div>
    );
  }
};

export default ExpertPrivateRoute;
